import * as t from "io-ts";
import { decimal, nullable } from "./index";
export const routeCargoRoadTollResponseT = t.type({
    cargoToll: nullable(decimal),
    routeToll: nullable(decimal),
    isCalculating: t.boolean,
    isOnRoute: t.boolean,
});
//# sourceMappingURL=road-cargo-road-toll.js.map